import React from 'react';
import {useLocalization} from 'localization';
import {Icon} from '../icons';
import type { ActionButtonV2Props} from './ActionButtonV2';
import {ActionButtonV2} from './ActionButtonV2';

export const SaveButton: React.FC<ActionButtonV2Props> = ({
  title,
  ...props
}) => {
  const {t} = useLocalization();
  const resolvedTitle = title ?? t('general.save');
  return (
    <ActionButtonV2
      showSpinnerOnClick
      startIcon={<Icon icon={'Check'} />}
      color={'success'}
      title={title}
      {...props}>
      {resolvedTitle}
    </ActionButtonV2>
  );
};
